module.exports = __webpack_public_path__ + "static/media/628ce092-fb46-4e63-99a6-8ef196018ca3.438d2f45.JPG";